import { CKLayoutGrid } from 'clearkit';

import { PageLayout } from '~/components/unified/PageLayout';

import { WhenProspector } from '../../policies/WhenProspector';
import { ContactSales } from '../CallsToAction/ContactSales';
import { FetchErrorRetry } from '../CallsToAction/FetchErrorRetry';
import { Listing } from '../Listing';
import { Loading } from '../Loading';
import { ProspectorSidebar } from '../Sidebar/ProspectorSidebar';
import { useProspector } from '../useProspector';
import { ProspectorProvider } from '../useProspector/Provider';

export function ProspectorShowPage() {
  return (
    <WhenProspector cta={<ContactSales />}>
      <ProspectorProvider>
        <CKLayoutGrid className="w-full" gap="0" gridTemplateColumns="auto 1fr">
          <ProspectorSidebar>
            <ProspectorSidebar.Breadcrumbs>
              New Prospect List
            </ProspectorSidebar.Breadcrumbs>
          </ProspectorSidebar>
          <PageLayout>
            <PageLayout.Header className="border-none bg-gray-0"></PageLayout.Header>
            <PageLayout.Body>
              <PageLayout.Content>
                <Prospector />
              </PageLayout.Content>
            </PageLayout.Body>
          </PageLayout>
        </CKLayoutGrid>
      </ProspectorProvider>
    </WhenProspector>
  );
}

function Prospector() {
  const [state] = useProspector();

  if (state.matches('loading')) {
    return <Loading />;
  } else if (state.matches('error')) {
    return <FetchErrorRetry />;
  }

  return <Listing />;
}
